import { Injectable } from '@angular/core';
import {NavigationExtras, Params} from '@angular/router';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class MapperService {

  constructor() { }

  /**
   * when url change
   * iterate over form to patch  each formGroup (object structure)
   * @param query
   */
  mapQueryToFormSelect(query: {query?: Params, extras?: NavigationExtras}, form: FormGroup): void {
    if (query) {
      form.patchValue(query);
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        if (control instanceof FormGroup) {
          const queryKey = query[key];
          if (key === 'countryCode') {
            form.get(key).patchValue({code: queryKey, name: queryKey})
          } else {
            form.get(key).patchValue({id: queryKey, name: queryKey})
          }
        }
      });
    }
  }
}
